import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../../analytics';
import { getCanonicalUrl, getMetaForPath, getPageTitle, INDEX_ROBOTS, SITE_NAME } from '../../utils/seo';


/**
 * Updates document title, meta description, Open Graph and Twitter Card tags on route change.
 * Also initializes GA and sends page_view when pathname changes.
 */
export function SeoHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const meta = getMetaForPath(pathname);
    const title = getPageTitle(meta.title);
    const description = meta.description;
    const canonicalUrl = getCanonicalUrl(pathname, window.location.origin);
    const robots = meta.robots ?? INDEX_ROBOTS;

    document.title = title;

    const setMetaContent = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaContent('description', description);
    setMetaContent('og:title', title, true);
    setMetaContent('og:description', description, true);
    setMetaContent('og:url', canonicalUrl, true);
    setMetaContent('og:type', 'website', true);
    setMetaContent('og:site_name', SITE_NAME, true);
    setMetaContent('twitter:card', 'summary_large_image');
    setMetaContent('twitter:title', title);
    setMetaContent('twitter:description', description);
    setMetaContent('robots', robots);
    setMetaContent('googlebot', robots);

    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = canonicalUrl;

    trackPageView(pathname, title);
  }, [pathname]);

  return null;
}
